export default ['en', 'es', 'pt']